import * as React from 'react';

// @ts-expect-error
import type {Fields} from 'redux-form/lib/FieldArrayProps.types.js.flow';

import {Button} from '../button/button';
import {Popover} from '../popover/popover';

import {SingleAttachment} from './single-attachment';

import styles from './attachment-count.module.css';

type Props = {
    attachments: Fields;
};
type State = {
    isExpanded: boolean;
};

export class AttachmentCountReduxForm extends React.Component<Props, State> {
    attachmentCount: HTMLElement | null | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            isExpanded: false,
        };
    }

    static getDerivedStateFromProps(props: Props, state: State) {
        // Prevent keeping isExpanded when all attachments are removed
        if (state.isExpanded && props.attachments.length === 0) {
            return {
                isExpanded: false,
            };
        }

        return null;
    }

    render() {
        if (this.props.attachments.length === 0) {
            return null;
        }

        // Show the name directly, unless the popover is expanded, in which
        // case another attachment was probably removed, and we don't want that
        // to cause the popover to close.
        if (this.props.attachments.length === 1 && !this.state.isExpanded) {
            return (
                <div className={styles['attachment-count']}>
                    <SingleAttachment
                        fileName={this.props.attachments.get(0).filename}
                        onRemove={() => {
                            this.props.attachments.remove(0);
                        }}
                    />
                </div>
            );
        }

        return (
            <div className={styles['attachment-count']}>
                <Button
                    // @ts-expect-error
                    getButtonRef={(node) => {
                        this.attachmentCount = node;
                    }}
                    variant='text-primary'
                    onClick={this.toggleExpand}
                >
                    {`${this.props.attachments.length} attached files`}
                </Button>
                {this.state.isExpanded ? (
                    <Popover
                        anchor={this.attachmentCount}
                        location='top'
                        onBlur={this.toggleExpand}
                    >
                        <ul className={styles['file-list']}>
                            {/* @ts-expect-error */}
                            {this.props.attachments.map((name, index) => (
                                <SingleAttachment
                                    fileName={this.props.attachments.get(index).filename}
                                    onRemove={() => {
                                        this.props.attachments.remove(index);
                                    }}
                                    key={name}
                                />
                            ))}
                        </ul>
                    </Popover>
                ) : null}
            </div>
        );
    }

    toggleExpand = () => {
        this.setState((prevState) => {
            return {
                isExpanded: !prevState.isExpanded,
            };
        });
    };
}
